import { Chip } from "@mui/material";

import { Negociacao } from "../../../models/enum";

type Props = {
  negociacao: Negociacao;
};

/**
 * Mercado → semântica de `palette.statusChip` (DESIGN.md → Chips de status):
 * - `accent` → BOVESPA, o mercado à vista, o caminho principal do app;
 * - `warn`   → BM&F, futuros e derivativos, apuração/alíquota com regra própria.
 * Mesma escolha usada em `classeChip` para DÓLAR/ÍNDICES/JUROS.
 */
export default function ChipNegociacao({ negociacao }: Props) {
  const semantica = negociacao === Negociacao.BOVESPA ? "accent" : "warn";

  return (
    <Chip
      label={negociacao}
      size="small"
      sx={(theme) => ({
        backgroundColor: theme.palette.statusChip[semantica].bg,
        color: theme.palette.statusChip[semantica].fg,
      })}
    />
  );
}
